import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'information-box',
  templateUrl: './information-box.component.html',
  styleUrls: ['./information-box.component.scss']
})
export class InformationBoxComponent implements OnInit {

  @Input() title;
  @Input() subTitle = null;
  @Input() icon;

  @Output() navigate: any = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

}
